import { TypographyText } from "@portal/BaseComponents/Typography/AntTypography";
import dayjs from "dayjs";
import { useMemo } from "react";

interface DueStatusProps {
  date: string;
}

type Due_Status_Types = "near" | "middle" | "over_due";
type DueStatusConfig = { label: string; color: string };

type DueStatusRecord = Record<Due_Status_Types, DueStatusConfig>;

const due_status_record: DueStatusRecord = {
  middle: {
    label: "days over due",
    color: "var(--red-4)",
  },
  near: {
    label: "Due in",
    color: "var(--orange-6)",
  },
  over_due: {
    label: "days over due",
    color: "var(--red-7)",
  },
};
function DueStatus(props: DueStatusProps) {
  const { date } = props;
  const currentDate = dayjs();
  const formattedDueDate = dayjs(date);
  const status = currentDate.diff(formattedDueDate, "days");
  function getDueConfig(): DueStatusConfig | undefined {
    return status > 0
      ? {
          ...due_status_record.over_due,
          label: `${Math.abs(status)} ${due_status_record.over_due.label}`,
        }
      : {
          ...due_status_record.near,
          label: `${due_status_record.near.label} ${Math.abs(status)} days `,
        };
  }

  const config = useMemo(getDueConfig, [status]);
  return (
    <TypographyText
      fs={"12"}
      style={{ color: config?.color }}
    >{`${config?.label}`}</TypographyText>
  );
}

export { DueStatus };
